var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-line"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label)+"：")]),_c('span',{staticClass:"value",style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.valueText))])])}
var staticRenderFns = []

export { render, staticRenderFns }